import { render, staticRenderFns } from "./CriarConta.vue?vue&type=template&id=92677b46&scoped=true"
import script from "./CriarConta.vue?vue&type=script&lang=ts"
export * from "./CriarConta.vue?vue&type=script&lang=ts"
import style0 from "./CriarConta.vue?vue&type=style&index=0&id=92677b46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92677b46",
  null
  
)

export default component.exports